import { render } from "./SummaryComp.vue?vue&type=template&id=23a5003d&scoped=true"
import script from "./SummaryComp.vue?vue&type=script&lang=js"
export * from "./SummaryComp.vue?vue&type=script&lang=js"

import "./SummaryComp.vue?vue&type=style&index=0&id=23a5003d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a5003d"]])

export default __exports__